import { capitalize } from 'lodash';

const Item = ({ method, isSelected, onSelect }) => {
  const { id, brand, last4, exp_month, exp_year } = method || {}

  return (
    <div onClick={() => onSelect(id)}
      className={`flex items-center justify-between p-4 rounded-xl border transition-all cursor-pointer select-none
        ${isSelected ? 'border-gray-900 bg-gray-50 shadow-xs' : 'border-gray-200/90 hover:border-gray-300 bg-white'}`}
    >
      <div className='space-y-1'>
        <h4 className="font-bold text-gray-900 text-base leading-tight">{capitalize(brand)}</h4>
        <p className="text-xs text-gray-400 font-medium mt-0.5">****{last4}</p>
      </div>
      <div className="text-right space-y-2">
        <span className="text-xs text-gray-400 font-normal block leading-tight">Expiry</span>
        <span className="text-xs text-gray-500 font-medium mt-0.5 block leading-tight">{exp_month}/{exp_year}</span>
      </div>
    </div>
  )
}

export default Item
